<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox1">
            <div class="item">
            <el-form-item label="成交时间:" prop="dealTimes">
              <el-date-picker
                  v-model="searchFrom.dealTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="委托方:" prop="entrustCode">
              <el-select  v-model="searchFrom.entrustCode"  placeholder="" filterable>
                <el-option v-for="val in WTlist" :label="val.tenantName" :value="val.tenantCode" :key="val.tenantCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="承运方:" prop="carriageCode">
              <el-select  v-model="searchFrom.carriageCode"  placeholder="" filterable>
                <el-option v-for="val in CYlist" :label="val.targetTenantName" :value="val.targetTenantCode" :key="val.targetTenantCode"></el-option>
              </el-select>
            </el-form-item>

            </div>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                 <el-form-item >
                  <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
       <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="orderNo"  min-width="220" :formatter="emptyFn" label="业务编号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dealTime"  min-width="120" :formatter="dateTimeFormat" label="成交时间"></el-table-column>
       <el-table-column prop="entrustName"  min-width="160" :formatter="emptyFn" label="委托方"></el-table-column>
       <el-table-column prop="carriageName"  min-width="160" :formatter="emptyFn" label="承运方"></el-table-column>
        <el-table-column prop="dealWeight"  min-width="130" :formatter="emptyFn" label="成交量(吨)" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import {
  sDemandOrderList
} from '@/api/data-center-server'
import {
  sTenantUserBindingRelList,
  selectTenantListFromCustomer
} from '@/api/soc-customer'
export default {
  data () {
    return {
      title: '',
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      WTlist: [],
      CYlist: [],
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    // this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    sTenantUserBindingRelList({
      businessType: 2,
      targetType: 1,
      tenantCode: localStorage.getItem('tenantCode')
    }).then(res => {
      this.CYlist = res
      if (res.length > 0) {
        this.CYlist.unshift({ targetTenantName: '全部', targetTenantCode: '' })
      }
    })
    selectTenantListFromCustomer({
      tenantBusinessCodes: '00000R,00000S,000017,000018,000008',
      tenantCode: localStorage.getItem('tenantCode')
    }).then(res => {
      this.WTlist = res
      if (res.length > 0) {
        this.WTlist.unshift({ tenantName: '全部', tenantCode: '' })
      }
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.dataCenterName + '/sDemandOrder/exportOrderList',
        form,
        '车队报表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      sDemandOrderList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1002:
          return '待竞价'
        case 1101:
          return '竞价中'
        case 1102:
          return '待比价'
        case 1203:
          return '竞价成功'
        case 1202:
          return '竞价失败'
        case 1201:
          return '已作废'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox1 .el-date-editor{
  width: 350px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
</style>
